import { PromoCodeSchema } from "@repo/common";
import { z } from "zod";

const type = PromoCodeSchema.shape.type;
const expiresOn = PromoCodeSchema.shape.expires_on;
const codeValue = PromoCodeSchema.shape.codeValue;

export const PromoCodesCreateFormSchema = z.object({
  amountCodes: z
    .number({
      error: (issue) =>
        issue.input === undefined
          ? "Bitte gebe eine Anzahl an Codes ein"
          : "Die Anzahl der Codes muss eine ganze Zahl sein",
    })
    .int({ message: "Die Anzahl der Codes muss eine ganze Zahl sein" })
    .min(1, { message: "Die Anzahl der Codes muss mindestens 1 sein" })
    .max(1000, { message: "Die Anzahl der Codes darf nicht größer als 1000 sein" }),
  type,
  expiresOn,
  codePrefix: z
    .string()
    .min(3, { message: "Der Prefix muss mindestens 3 Zeichen lang sein" })
    .max(9, { message: "Der Prefix darf nicht länger als 9 Zeichen sein" })
    .refine((prefix) => /^[A-Z0-9]+$/i.test(prefix), {
      message: "Prefix darf nur Buchstaben und Zahlen enthalten",
    }),
  codeValue,
});

export type PromoCodesCreateFormType = z.infer<typeof PromoCodesCreateFormSchema>;

export type PromoCodesCreateFormFieldErrors = Partial<Record<keyof PromoCodesCreateFormType, string>>;
